































































import Vue from 'vue';
import jwt_decode from 'jwt-decode';

import { iconsMixin } from '../../mixins/icons';

import authService from '../../services/AuthService';
import settingService from '../../services/SettingService';
import menuService from '../../services/MenuService';
import logsService from '../../services/LogsService';
import miscService from '../../services/MiscService';
import routeService from '../../services/RouteService';
import localStorageService from '@/services/LocalStorageService';

import { User } from '../../models/sso/User';
import { UserDefaultSettings } from '@/models/setting/UserDefaultSettings';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin],
  data() {
    return {
      loading: true,
      users: [] as User[],
    };
  },
  created() {
    if (!this.isWatscoCallback) {
      this.validateUserToken();
      return;
    }

    this.validateWatscoUser();
  },
  methods: {
    saveUserAndRedirect(user: User) {
      authService.setUserSession(user);
      logsService.log(miscService.getScreenSizeLogMessage());
      localStorageService.set('dashboard-visited', false);
      document.location.href = menuService.getHomePageUrl(user);
    },
    validateWatscoUser(): void {
      let user = null;
      authService
        .validateWatscoAuthCode(this.watscoAccessCode)
        .then((x) => {
          if (this.checkMultipleAccountsAccess(x)) {
            return;
          }

          const jwtToken = x?.jwt as string;
          var decoded = jwt_decode(jwtToken);
          user = decoded as User;

          if (!user?.company && !user?.isAdmin) {
            miscService.goToPage('/access-denied');
            return;
          }

          user.jwtToken = jwtToken;
          this.setDefaults(user);
        })
        .catch(() => {
          miscService.goToPage('/access-denied');
        });
    },
    getWatscoAADUrl(sub) {
      let baseUrl = `https://afslogistics.auth0.com/authorize?response_type=code&responseMode=form_post&client_id=ILjA3q8lnlF7SsGiCWHiwO2iXfyQQdlp&redirect_uri=https://${document.location.host}/sso/login/watsco&connection=`;
      if (sub == 'waad|') {
        baseUrl += 'Watsco-Azure-AD';
      } else if (sub == 'baad|') {
        baseUrl += 'BakerDist-Azure-AD';
      } else if (sub == 'gaad|') {
        baseUrl += 'Gemaire-Azure-AD';
      } else if (sub == 'eaad|') {
        baseUrl += 'EastCoastMetals-Azure-AD';
      } else if (sub == 'caad|') {
        baseUrl += 'CarrierEnt-Azure-AD';
      }

      return baseUrl;
    },
    isWatscoSub(sub) {
      return (
        sub?.includes('waad|') ||
        sub?.includes('baad|') ||
        sub?.includes('gaad|') ||
        sub?.includes('eaad|') ||
        sub?.includes('caad|')
      );
    },
    checkIfNeedsToRedirectToWatscoAADPage(sub) {
      const getWatscoUrl = this.getWatscoAADUrl(sub);
      miscService.goToPage(getWatscoUrl);
      return;
    },
    validateUserToken(): void {
      let user = null;
      authService
        .validateAuthCode(this.hashToken)
        .then((x) => {
          if (this.checkMultipleAccountsAccess(x)) {
            return;
          }

          const jwtToken = x?.jwt as string;
          if (jwtToken) {
            var decoded = jwt_decode(jwtToken);
            user = decoded as User;
          }

          const userNotFound = !user?.company && !user?.isAdmin;
          if (userNotFound && !x?.sub) {
            miscService.goToPage('/access-denied');
            return;
          } else if (userNotFound && this.isWatscoSub(x?.sub)) {
            this.checkIfNeedsToRedirectToWatscoAADPage(x.sub);
            return;
          } else if (userNotFound) {
            miscService.goToPage('/access-denied');
          }

          user.jwtToken = jwtToken;
          this.setDefaults(user);
        })
        .catch(() => {
          miscService.goToPage('/access-denied');
        });
    },
    checkMultipleAccountsAccess(x) {
      if (x?.users?.length > 1) {
        this.loading = false;
        this.users = x.users;

        return true;
      }

      return false;
    },
    setDefaults(user: User) {
      if (user.accountId && user.userId) {
        // set jwt
        authService.setUserSession(user);

        settingService
          .getUserDefaults(user.accountId, user.userId)
          .then((x: UserDefaultSettings) => {
            user.defaultSettings = x;
            this.saveUserAndRedirect(user);
          });
      } else {
        this.saveUserAndRedirect(user);
      }
    },
    accountSelected(user) {
      const params = this.queryParams;
      miscService.goToPage(
        `/sso/login?#signature=${params.access_token}&access_token=${user.userId}`
      );
    },
  },
  computed: {
    multipleAccountsDetected() {
      return this.users.length > 1 && !this.loading;
    },
    singleAccountLogin() {
      return !this.multipleAccountsDetected;
    },
    greeting() {
      return miscService.greeting();
    },
    hashToken() {
      return this.queryParams.access_token;
    },
    watscoAccessCode() {
      return this.queryParams.code;
    },
    queryParams() {
      return routeService.getQueryParameters();
    },
    isWatscoCallback() {
      return document.location.href.includes('sso/login/watsco?code=');
    },
  },
});
